import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=929210c8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=929210c8&prod&lang=less&scoped=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=929210c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929210c8",
  null
  
)

export default component.exports